/* eslint-disable
    consistent-return,
    no-func-assign,
    no-new,
    no-return-assign,
    no-unused-vars
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import notifications from 'notifications';
import * as popup from 'Popup';
import * as tour from 'help/Tour';

class OrganizationRow extends Backbone.View {
  static initClass() {
    this.prototype.events = {'click .leave-button': 'leaveOrg'};
  }

  initialize(options) {
    return ({removeCallback: this.removeCallback} = options);
  }

  remove() {
    super.remove();
    return this.removeCallback();
  }

  leaveOrg() {
    let p;
    const organizationId = this.$el.data('organizationId');
    const organizationHandle = this.$el.data('organizationHandle');
    const msg = `Are you sure you want to leave ${organizationHandle}? You'll lose access to all shared items including folders and sequences.`;

    function callback() {
      return $.ajax({
        url: `/1/api/organizations/${organizationId}/users/me`,
        type: 'DELETE',
      })
        .fail(notifications.notifyError) // eslint-disable-next-line no-restricted-syntax
        .done(_.bind(this.remove, this));
    }

    // eslint-disable-next-line no-restricted-syntax
    callback = _.bind(callback, this);
    return (p = new popup.Confirm({title: `Leaving ${organizationHandle}`, msg})
      .choice('Confirm Leaving', 'btn-af-danger', callback)
      .choice('Cancel', 'btn-af-default')
      .show());
  }
}
OrganizationRow.initClass();

class ManageOrganizationsView extends Backbone.View {
  static initClass() {
    this.prototype.el = '#organizations';
  }

  render() {
    function removeCallback() {
      if (this.$el.find('.organizations-list li').length === 0) {
        return this.$el.find('.no-organizations').removeClass('hidden');
      }
    }

    // eslint-disable-next-line no-restricted-syntax
    removeCallback = _.bind(removeCallback, this);
    for (const row of Array.from(this.$el.find('.organizations-list li'))) {
      new OrganizationRow({el: row, removeCallback});
    }

    return this;
  }
}
ManageOrganizationsView.initClass();

export default ManageOrganizationsView;
